export type UserNavbarCountry = {
    name: string;
    code: string;
    flag: string;
};

export type UserNavbarLanguage = {
    name: string;
    shortName: string;
    flag: string;
};

export type UserNavbarCurrency = {
    code: string;
    symbol: string;
    name: string;
};

export type UserNavbarProfile = {
    name: string;
    userId: string;
    email?: string;
    image?: string;
    initial?: string;
};

export const USER_NAVBAR_COUNTRIES: UserNavbarCountry[] = [
    {
        name: "India",
        code: "IN",
        flag: "🇮🇳",
    },
    {
        name: "United States",
        code: "US",
        flag: "🇺🇸",
    },
    {
        name: "United Kingdom",
        code: "GB",
        flag: "🇬🇧",
    },
    {
        name: "United Arab Emirates",
        code: "AE",
        flag: "🇦🇪",
    },
    {
        name: "Canada",
        code: "CA",
        flag: "🇨🇦",
    },
    {
        name: "Australia",
        code: "AU",
        flag: "🇦🇺",
    },
];

export const USER_NAVBAR_LANGUAGES: UserNavbarLanguage[] = [
    {
        name: "English",
        shortName: "EN",
        flag: "🇬🇧",
    },
    {
        name: "Hindi",
        shortName: "HI",
        flag: "🇮🇳",
    },
    {
        name: "Telugu",
        shortName: "TE",
        flag: "🇮🇳",
    },
    {
        name: "Tamil",
        shortName: "TA",
        flag: "🇮🇳",
    },
    {
        name: "Kannada",
        shortName: "KN",
        flag: "🇮🇳",
    },
    {
        name: "Malayalam",
        shortName: "ML",
        flag: "🇮🇳",
    },
];

export const USER_NAVBAR_CURRENCIES: UserNavbarCurrency[] = [
    {
        code: "INR",
        symbol: "₹",
        name: "Indian Rupee",
    },
    {
        code: "USD",
        symbol: "$",
        name: "US Dollar",
    },
    {
        code: "EUR",
        symbol: "€",
        name: "Euro",
    },
    {
        code: "GBP",
        symbol: "£",
        name: "British Pound",
    },
    {
        code: "AED",
        symbol: "د.إ",
        name: "UAE Dirham",
    },
];

export const DEFAULT_USER_NAVBAR_PROFILE: UserNavbarProfile = {
    name: "My Account",
    userId: "N/A",
    email: "",
    image: "",
    initial: "S",
};
